import React from 'react';
import ReactDOM from 'react-dom';
import LoadingSmall from '../components/LoadingSmall.js';
import Notification from './Notification';
import axios from 'axios';
import Select from 'react-select';

const CancelToken = axios.CancelToken;
let cancel;

class AudiencePicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'isLoading':true,
            'audiences':[],
            'error':false,
            'isCreating':false,
            'audiance_name':''
        };

        this.buildAudienceList = this.buildAudienceList.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onInteractionChange = this.onInteractionChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.addToList = this.addToList.bind(this);
    }

    addToList() {
        this.setState({
            isLoading:true,
            isCreating:false,
        });

        axios.post('/apps/FacebookAds/CreateAudience',{name:this.state.audiance_name}).then(res => {
           this.getAudience();
        });
    }

    handleNameChange(e) {
        this.setState({audiance_name:e.target.value});
    }

    onInteractionChange(e) {
        this.props.change('remove_on_interaction',e.target.checked);
    }

    onChange(e) {
        this.props.change('audience_id',e);
    }

    getAudience() {
        axios.get('/apps/FacebookAds/GetAudiences').then(res => {


            if(res.data.success === false) {
                this.setState({
                    isLoading:false,
                    error:res.data.message,
                });
            }else{
                this.setState({
                    isLoading:false,
                    audiences:res.data,
                });
            }
        });
    }

    buildAudienceList() {
        let list = [];

        this.state.audiences.map(item => {
            list.push({
                'label':item.name,
                'value':item.id,
            })
        });

        return list;
    }

    componentWillMount() {
        this.getAudience();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <div className="col-sm-12">
                    <LoadingSmall/>
                </div>
            );
        }

        if(this.state.error !== false) {
            return (
                <div className="col-sm-12">
                    <div className="alert alert-danger alert-dismissible" role="alert">
                        {this.state.error}
                    </div>
                </div>
            );
        }

        return (
            <div className="col-sm-10 offset-sm-2">
                <div className="col-sm-6">
                    <Select
                        value={this.props.segment.audience_id}
                        onChange={this.onChange}
                        options={this.buildAudienceList()}
                        placeholder="Select an existing audience"
                        simpleValue
                    />
                </div>
                <div className="col-sm-6">
                    {
                        this.state.isCreating === false ?
                            <button className="btn btn-block btn-dark" onClick={() => { this.setState({isCreating:true,audiance_name:''})} }><i className="icon wb-plus"></i> Or create a new audience</button>
                            :
                            <div>
                                <input type="text" ref="audiance_name" placeholder="My new custom audiance" value={this.state.audiance_name} onChange={this.handleNameChange} className="form-control" />
                                <br />
                                <button className="btn btn-block btn-dark" onClick={this.addToList}>Add to list</button>
                            </div>
                    }
                </div>
                <div className="col-sm-6">
                    <div className="checkbox-custom checkbox-primary">
                        <input type="checkbox" checked={this.props.segment.remove_on_interaction} onChange={this.onInteractionChange} />
                        <label> Remove from audience on customer interaction</label>
                    </div>
                </div>
            </div>
        );
    }
}




export default AudiencePicker;


// WEBPACK FOOTER //
// ./components/AudiencePicker.js